import  { lazy } from 'react';
import Auth from "../../hoc/Auth";

const paymentPromise = import("./ProcessPayment.js");
export default Auth(lazy(() => paymentPromise));